export default "__VITE_ASSET__CCcKpYu___"